export const getImgContentType = (img) => {
  return fetch(img.src, { method: "HEAD" }).then((response) =>
    response.headers.get("content-type")
  );
};

export const getImageType = async (img) => {
  const contentType = await getImgContentType(img);
  if (!contentType) return false;
  if (contentType === "image/jpeg") return "JPEG";
  if (contentType === "image/png") return "PNG";
  if (contentType === "image/webp") return "WEBP";
  return false;
};
